import { FormItemType, GridInputValue } from '../../types/types';

// Numeric layout fields must hold numbers (the PUT schema is typed); inputs like
// ReferenceInput emit the picked id as a string. A cleared numeric input turns
// into an explicit null — '' would violate the schema, and an omitted key keeps
// the stored value on the server instead of clearing it.
export const coerceLayoutFieldValue = (
  type: FormItemType | undefined,
  value: GridInputValue
): GridInputValue => {
  const isNumericField = type === 'integer' || type === 'float';

  if (!isNumericField) {
    return value;
  }

  if (value === '' || value === undefined) {
    return null;
  }

  if (typeof value === 'string' && !Number.isNaN(Number(value))) {
    return Number(value);
  }

  return value;
};
